/** Storage keys used across the app (localStorage / sessionStorage). */
const Keys = {
  JWT_TOKEN: 'AivoJwtToken',
  /**
   * The scoped token `POST /public/document/:id/:accessCode/verify` mints
   * (`scope: "public-document"` + `documentId`). It is NOT a portal session — the api
   * refuses it everywhere except the /public/document/* routes — so it must never share
   * JWT_TOKEN, which would clobber a signed-in user's session. Read/written only through
   * the public-document seam in `src/api/API.ts`.
   */
  PUBLIC_DOCUMENT_TOKEN: 'AivoPublicDocumentToken',
  TEMP_PHONE: 'tempPhone',
  TEMP_USER_DATA: 'tempUserData',
  TEMP_SMS_TOKEN: 'tempSmsToken',
  /** Legacy: never written; kept so logout clears a bexio token left by earlier builds. */
  BEXIO_TOKEN: 'BexioJwtToken',
  LAST_VISITED_PAGE: 'AIVO_LAST_VISITED_PAGE',
  PREVIOUS_VISITED_PAGE: 'AIVO_PREVIOUS_VISITED_PAGE',
  BEXIO_REDIRECT_URL: 'BexioRedirectURL',
  BEXIO_REQUEST_DATA: 'BexioRequestData',
} as const;

export default Keys;
